<div (click)="toggle()">
  <ng-content select="[toggle]"></ng-content>
</div>

<ng-container *ngIf="!collapsed">
  <ng-content select="[collapsable]"></ng-content>
</ng-container>
